import React from 'react';
import Loader from 'utils/Loader';
import { validateResetPasswordForm } from 'utils/validationUtils';
import ResetPasswordController from './ResetPasswordController';

function ResetPassword() {
  const {
    formData,
    errors,
    apiError,
    loading,
    handleChange,
    handleResetPassword,
    handleBackToLogin
  } = ResetPasswordController({ new_password: '' }, validateResetPasswordForm);
  
  return (
    <div className="login">
      <div className="form">
        <form onSubmit={handleResetPassword}>
          <span className="span-forwpass" style={{ color: 'white'}}>Reset Password</span>
          <input
            type="text"
            name="new_password"
            placeholder="New Password"
            className="form-control inp_text"
            value={formData.new_password}
            onChange={handleChange}
          />
          <p className="error">{errors.new_password}</p>

          <span
            role="button"
            tabIndex={0}
            style={{ display: 'flex', justifyContent: 'end', cursor: 'pointer' }}
            onClick={handleBackToLogin}
            onKeyDown={(e) => { if (e.key === 'Enter') handleBackToLogin(); }}
          >
            Back To Login
          </span>

          <div style={{ marginTop: '20px' }}>
            <p className="error">{apiError}</p>
            <button type="submit" disabled={loading}>
              {loading ? <Loader /> : 'Reset'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
